import { Link } from "react-router-dom";

const ValousePreinscription = () => {
  return (
    <div className="min-h-screen bg-[#F3E5CF] flex items-center justify-center px-6 py-16">
      <div className="max-w-md w-full bg-[#F3E5CF] rounded-3xl border border-[#EAD3AE]/60 shadow-lg px-8 py-10 space-y-6 text-[#4B3329]">
        {/* Retour */}
        <div className="text-left mb-2">
          <Link
            to="/valouse"
            className="text-xs tracking-[0.25em] uppercase text-[#8C6A4A] hover:text-[#C5A059] transition-colors"
          >
            ← Retour à COCON Valouse
          </Link>
        </div>

        <div className="space-y-3 text-sm leading-relaxed">
          <p className="font-semibold">Les préinscriptions sont ouvertes.</p>
          <p>
            En laissant ton adresse,
            <br />
            tu recevras un lien personnel avec 10 % de réduction,
            <br />
            valable durant les 10 premiers jours
            <br />
            suivant l’ouverture officielle de la billetterie.
          </p>
          <p>
            Sans engagement.
            <br />
            Simplement une façon d’honorer celles et ceux
            <br />
            qui ressentent l’appel en amont.
          </p>
        </div>

        {/* Champ email simple (cosmétique pour l’instant) */}
        <form className="mt-4 space-y-4">
          <input
            type="email"
            required
            placeholder="ton@email.com"
            className="w-full px-4 py-2 rounded-full border border-[#EAD3AE] bg-white text-center text-sm text-[#3F2A24] placeholder:text-[#8C6A4A] focus:outline-none focus:ring-2 focus:ring-[#C5A059]/60"
          />
          <button
            type="submit"
            className="w-full inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-[#3F2A24] text-[#F3E5CF] text-xs tracking-[0.3em] uppercase font-medium shadow-md hover:bg-[#4B3329] transition-colors"
          >
            Recevoir l’invitation early bird
          </button>
        </form>
      </div>
    </div>
  );
};

export default ValousePreinscription;
